<template>
  <b-row>
    <b-col>
      <b-card :class="{ open: visibleBody }" style="margin:0">
        <b-card-header
          :class="{ collapsed: !visibleBody }"
          role="tab"
          @click="onVisibleBody()"
          style="background-color: #0080C9; color: white; font:45px; padding: 15px; cursor: pointer;"
        >
          <span class="lead collapse-title"><strong>TERAPIAS</strong></span>
          <i :class="visibleBody ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"/>
        </b-card-header>

        <b-collapse
          v-model="visibleBody"
          role="tabpanel"
        >

          <b-card-body style="margin:0; border:1px solid #2980b9;">

            <!-- <span>{{'tokenAtencion ' + tokenAtencion }}</span> -->

            <div 
              class="row d-flex align-items-center mt-1" 
              style="position: relative;"
            >
              <CommentEditor
                v-if="isAuditoria"
                field="terapias"
                :comentarios="comentarios"
              />
            </div>

            <TerapiasList
              onlyView
              v-if="terapias && terapias.length"
              v-model="terapias"
            />

            <EmptyResults 
              v-if="!terapias || terapias.length === 0"
              :message="'No se encontraron terapias para mostrar.'"
            />
          </b-card-body>

        </b-collapse>
      </b-card>
    </b-col>

  </b-row>
</template>

<script>
import { EmptyResults }    from '@/shared/components';
import { terapiasService } from '@/views/terapia/services';
import { TerapiasList }    from '@/views/terapia/components';
import CommentEditor       from '../CommentEditor/CommentEditor.vue';

export default {
  name: "AtencionTerapias",

  props:{
    tokenAtencion:{
      type: String,
      required: true
    },

    isAuditoria: {
      type: Boolean,
      default: false
    },
  },

  components: {
    EmptyResults,
    CommentEditor,
    TerapiasList
  },

  data() {
    return {
      visibleBody: false,
      terapias: null,

      comentarios:{}
    };
  },

  created(){
    this.onGetData();
  },

  
  methods: {
    onVisibleBody() {
      this.visibleBody = !this.visibleBody;
    },

    async onGetData(){
      const data = await terapiasService.getByAtencion(this.tokenAtencion);
      console.log('las terapias', data);

      if (!data) return;
      this.terapias = data;
    }

  },

  watch: {

    comentarios:{
      deep: true,
      handler(newValue) {
        const comentario = newValue.terapias || null;
        this.$store.commit("setComentarios", { terapias: comentario });
      }
    }
  }
}
</script>
